import React from 'react';
import PureRenderMixin from 'react-pure-render/mixin';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import ItemRowMenu from 'main/components/show/cuesheet/itemCell/rowMenu';
import GlobalElementRowMenu from 'main/components/show/cuesheet/itemCell/globalElementRowMenu';
import TagRowMenu from 'main/components/show/cuesheet/itemCell/tagRowMenu';
import { isCompact } from 'main/components/show/cuesheet/cuesheetViewHelper';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';

export default React.createClass({
  displayName: 'RowMenuBar',

  mixins: [PureRenderMixin],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
  },

  render() {
    const params = this.context.router.state.params;
    const isCompactView = isCompact();

    const { rowIndex, disableReordering } = this.props;

    let arrowUp = isCompactView ? (
      <span
        className="fa pointer"
        onClick={() => CuesheetRowActions.moveItemRowUp(rowIndex)}
      />
    ) : (
      <Icon
        name="angle-up"
        onClick={() => CuesheetRowActions.moveItemRowUp(rowIndex)}
      />
    );
    let arrowDown = isCompactView ? (
      <span
        className="fa pointer"
        onClick={() => CuesheetRowActions.moveItemRowDown(rowIndex)}
      />
    ) : (
      <Icon
        name="angle-down"
        onClick={() => CuesheetRowActions.moveItemRowDown(rowIndex)}
      />
    );

    if (disableReordering) {
      arrowUp = null;
      arrowDown = null;
    }

    return (
      <div className="row-menu-bar">
        <DisplayForAdmin {...params}>
          <span className="row-menu-up">{arrowUp}</span>
        </DisplayForAdmin>

        <DisplayForAdmin {...params}>
          <span className="row-menu-down">{arrowDown}</span>
        </DisplayForAdmin>

        <TagRowMenu {...this.props} />
        <GlobalElementRowMenu {...this.props} />
        <ItemRowMenu {...this.props} />
      </div>
    );
  },
});
